import * as Sentry from "@sentry/browser";

import env from "./env";
import { isClientSide, isMobile } from "./helpers/client";
import {
    beforeSendSentryEvent,
    sentryDenyUrls,
    sentryPerformanceTracingOptions,
} from "./sentry-client-config";

/**
 * Sentry initialization for Blade (non-Vue) pages.
 *
 * Blade pages load `blade-app.ts`, which does not boot the Vue app, so the
 * Sentry init in `app.ts` never runs for them. Without this, migrated pages
 * (home, etc.) drop out of RUM entirely — no Web Vitals, no INP attribution.
 *
 * Mirrors the config in `app.ts` so Blade pages report the same data:
 * `browserTracingIntegration` captures INP as standalone spans with the
 * interacted element as `span.description`, which is what lets us pinpoint
 * slow interactions per page in Sentry.
 */
if (env.VITE_SENTRY_ENABLED !== "false") {
    Sentry.init({
        dsn: env.VITE_SENTRY_DSN_PUBLIC,
        environment: env.VITE_SENTRY_ENVIRONMENT,

        integrations: [Sentry.browserTracingIntegration()],

        tracePropagationTargets: [
            "localhost",
            /^https:\/\/(.+\.)?joinsteer\.com/,
            /^https:\/\/(.+\.)?joinsteer\.fr/,
            /^\/api\//,
        ],

        sampleRate: parseFloat(env.VITE_SENTRY_SAMPLE_RATE || "0.1"),
        ...sentryPerformanceTracingOptions(env.VITE_SENTRY_TRACES_SAMPLE_RATE),

        denyUrls: sentryDenyUrls,
        beforeSend: beforeSendSentryEvent,
    });

    Sentry.setTag(
        "device_type",
        isClientSide() && isMobile() ? "mobile" : "desktop",
    );

    if (isClientSide()) {
        Sentry.setContext("viewport", { width: window.innerWidth });
    }
}
